import React from 'react';
import PageLogin from './pages/PageLogin'
import PageRejister from './pages/PageRejister'
import PageHome from './pages/PageHome'
import PageScoreUser from './pages/PageScoreUser'
import PageTestRound from './pages/PageTestRound'
import PageTestScore from '../src/pages/PageTestScore'
import PageManageQuestion from './pages/PageManageQuestion';
import PageManageUser from './pages/PageManageUser'
import PageEditUserData from './pages/PageEditUserData'
import PageEditInformation from './pages/PageEditInformation'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import UserLoginRoute from '../src/components/UserLoginRoute'
import Notfound404 from "../src/components/Notfound404";
import PagePublicRelations from "../src/pages/PagePublicRelations"
import PageResultGraph from "../src/pages/PageResultGraph";
import PageResultGraphUnits from "../src/pages/PageResultGraphUnits"
import { YearProvider } from '../src/components/usecontext/YearContext'; // ระบุ path ที่ถูกต้องสำหรับ YearContext

function App() {
  return (
    <YearProvider>
    <Router>

      <Routes>
        <Route path="/notfound404" element={<Notfound404 />} />
        <Route
          path="*"
          element={
            <Notfound404 text="The page you’re looking for doesn’t exist." />
          }
        />
        
        <Route path="/" element={<PagePublicRelations />} />
        <Route path="/PageLogin" element={<PageLogin />} />
        <Route path="/PageRejister" element={
          <UserLoginRoute>
            <PageRejister />
          </UserLoginRoute>
        } />

        <Route path="/PageResultGraph" element={
          <UserLoginRoute><PageResultGraph /></UserLoginRoute>

        } />
        <Route path="/PageResultGraphUnits" element={
          <UserLoginRoute><PageResultGraphUnits /></UserLoginRoute>

        } />
        <Route path="/PageHome" element={
          <UserLoginRoute><PageHome /></UserLoginRoute>

        } />
        <Route path="/PageScoreUser" element={
          <UserLoginRoute><PageScoreUser /></UserLoginRoute>
        } />
        <Route path="/PageTestRound" element={
          <UserLoginRoute><PageTestRound /></UserLoginRoute>
        } />
        <Route path="/PageTestScore" element={
          <UserLoginRoute><PageTestScore /></UserLoginRoute>
        } />
        <Route path="/PageManageQuestion" element={
          <UserLoginRoute><PageManageQuestion /></UserLoginRoute>
        } />
        <Route path="/PageManageUser" element={
          <UserLoginRoute><PageManageUser /></UserLoginRoute>
        } />
        <Route path="/PageEditUserData" element={
          <UserLoginRoute><PageEditUserData /></UserLoginRoute>
        } />
        <Route path="/PageEditInformation" element={
          <UserLoginRoute><PageEditInformation /></UserLoginRoute>
        } />
      </Routes>

    </Router>
    </YearProvider>
  )
}

export default App;
